import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { closestCenter, DragOverlay, DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import ReactDOM from "react-dom";
import { dropAnimationConfig } from './dropAnimationConfig';
import { DRAG_OVERLAY_CLOSE, DRAG_OVERLAY_WRAPPER } from './constants';
export const SortableList = (props) => {
    const { moveRows, items, activeRowIndex, setActiveRowIndex, renderOverlayItem, children } = props;
    const getIndexById = (id) => items.find(x => x.key === id)?.index ?? -1;
    const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor), useSensor(KeyboardSensor, {
        scrollBehavior: 'Cypress' in window ? 'auto' : undefined,
    }));
    const renderOverlay = () => {
        return ReactDOM.createPortal(_jsx(DragOverlay, { adjustScale: false, dropAnimation: dropAnimationConfig, className: DRAG_OVERLAY_WRAPPER, children: renderOverlayItem() }), document.activeElement?.closest("dialog") ?? document.body);
    };
    return _jsx(DndContext, { sensors: sensors, collisionDetection: closestCenter, 
        // modifiers={[restrictToFirstScrollableAncestor, restrictToVerticalAxis]}
        onDragStart: ({ active }) => {
            const activeIndex = getIndexById(active.id);
            setActiveRowIndex(activeIndex);
        }, onDragEnd: dragEndProps => {
            const { over } = dragEndProps;
            document.querySelector(`.${DRAG_OVERLAY_WRAPPER}`)?.classList.add(DRAG_OVERLAY_CLOSE);
            setActiveRowIndex(undefined);
            if (activeRowIndex !== undefined && over && over.id) {
                const activeDataIndex = activeRowIndex;
                const overDataIndex = getIndexById(over.id);
                if (activeDataIndex !== overDataIndex) {
                    moveRows?.(activeDataIndex, overDataIndex);
                }
            }
        }, onDragCancel: () => setActiveRowIndex(undefined), children: _jsxs(SortableContext, { items: items.map(x => ({ id: x.key })), strategy: verticalListSortingStrategy, children: [children, renderOverlay()] }) });
};
